export { default as RectangleSpinner } from "./RectangleSpinner";



// WEBPACK FOOTER //
// ./src/components/common/spinners/index.js